<form #f="ngForm" (ngSubmit)="submit(f)" novalidate>
  <nb-card class="dialog-card">
    <nb-card-header>
      <h4>{{
        (isEdit
          ? "pages.learnings.dialog.editTitle"
          : scope === "bot"
            ? "pages.learnings.dialog.newTitleBot"
            : "pages.learnings.dialog.newTitleClient"
        ) | translate
      }}</h4>
    </nb-card-header>

    <nb-card-body>
      <!-- Provenance: what the expert wrote about the answer this learning
           was made from. Read-only — it is the input, the form the output. -->
      <div class="provenance" *ngIf="fromConversation">
        <span class="label">{{ "pages.learnings.provenance.title" | translate }}</span>
        <p *ngIf="expertNote" class="provenance__note">{{ expertNote }}</p>
      </div>

      <!-- Rule vs example is the one choice people get wrong; the hint says
           what each one does to the agent, not what the field is called. -->
      <div class="form-field">
        <label class="label">
          {{ "pages.learnings.fields.type" | translate }}
          <nb-icon
            icon="question-mark-circle-outline"
            class="hint-icon"
            nbPopover="{{ 'pages.learnings.hints.type' | translate }}"
            nbPopoverTrigger="hover"
            nbPopoverPlacement="bottom"
          ></nb-icon>
        </label>
        <nb-select
          fullWidth
          size="small"
          name="type"
          [selected]="model.type"
          (selectedChange)="onTypeChange($event)"
        >
          <nb-option value="rule">{{ "pages.learnings.types.rule" | translate }}</nb-option>
          <nb-option value="qa_example">{{ "pages.learnings.types.qa_example" | translate }}</nb-option>
        </nb-select>
      </div>

      <div class="form-field">
        <label class="label">
          {{ "pages.learnings.fields.topic" | translate }}
          <nb-icon icon="question-mark-circle-outline" class="hint-icon"
            nbPopover="{{ 'pages.learnings.hints.topic' | translate }}" nbPopoverTrigger="hover" nbPopoverPlacement="right"></nb-icon>
        </label>
        <input
          nbInput
          fullWidth
          fieldSize="small"
          name="topic"
          maxlength="255"
          [(ngModel)]="model.topic"
          [placeholder]="'pages.learnings.fields.topicPlaceholder' | translate"
        />
      </div>

      <div class="form-field" *ngIf="isExample">
        <label class="label">
          {{ "pages.learnings.fields.question" | translate }} *
          <nb-icon icon="question-mark-circle-outline" class="hint-icon"
            nbPopover="{{ 'pages.learnings.hints.question' | translate }}" nbPopoverTrigger="hover" nbPopoverPlacement="right"></nb-icon>
        </label>
        <textarea
          nbInput
          fullWidth
          rows="2"
          name="question"
          required
          [(ngModel)]="model.question"
          [placeholder]="'pages.learnings.fields.questionPlaceholder' | translate"
        ></textarea>
      </div>

      <div class="form-field">
        <label class="label">
          {{
            (isExample
              ? "pages.learnings.fields.answer"
              : "pages.learnings.fields.instruction"
            ) | translate
          }}
          *
          <nb-icon icon="question-mark-circle-outline" class="hint-icon"
            nbPopover="{{ 'pages.learnings.hints.content' | translate }}" nbPopoverTrigger="hover" nbPopoverPlacement="right"></nb-icon>
        </label>
        <textarea
          nbInput
          fullWidth
          rows="5"
          name="content"
          required
          [(ngModel)]="model.content"
          [placeholder]="
            (isExample
              ? 'pages.learnings.fields.answerPlaceholder'
              : 'pages.learnings.fields.instructionPlaceholder'
            ) | translate
          "
        ></textarea>
      </div>

      <div class="form-field">
        <label class="label">
          {{ "pages.learnings.fields.tags" | translate }}
          <nb-icon icon="question-mark-circle-outline" class="hint-icon"
            nbPopover="{{ 'pages.learnings.hints.tags' | translate }}" nbPopoverTrigger="hover" nbPopoverPlacement="right"></nb-icon>
        </label>
        <input
          nbInput
          fullWidth
          fieldSize="small"
          name="tags"
          [(ngModel)]="tagsText"
          [placeholder]="'pages.learnings.fields.tagsPlaceholder' | translate"
        />
      </div>

      <!-- Anchors decide whether the agent FINDS the learning: its own text
           reads like an instruction, a learner asks differently. -->
      <div class="form-field">
        <label class="label">
          {{ "pages.learnings.fields.anchors" | translate }}
          <nb-icon
            icon="question-mark-circle-outline"
            class="hint-icon"
            nbPopover="{{ 'pages.learnings.hints.anchors' | translate }}"
            nbPopoverTrigger="hover"
            nbPopoverPlacement="bottom"
          ></nb-icon>
        </label>
        <textarea
          nbInput
          fullWidth
          rows="4"
          name="anchors"
          [(ngModel)]="anchorsText"
          [placeholder]="'pages.learnings.fields.anchorsPlaceholder' | translate"
        ></textarea>
        <span class="hint" [class.hint--warning]="tooManyAnchors">
          {{ "pages.learnings.fields.anchorsCount" | translate: { count: anchorCount, max: maxAnchors } }}
        </span>
      </div>

      <div class="form-field">
        <label class="label">
          {{ "pages.learnings.fields.course" | translate }}
          <nb-icon icon="question-mark-circle-outline" class="hint-icon"
            nbPopover="{{ 'pages.learnings.hints.course' | translate }}" nbPopoverTrigger="hover" nbPopoverPlacement="right"></nb-icon>
        </label>
        <nb-select
          fullWidth
          size="small"
          name="course_id"
          [(selected)]="model.course_id"
          [placeholder]="'pages.learnings.fields.allCourses' | translate"
        >
          <nb-option [value]="null">{{ "pages.learnings.fields.allCourses" | translate }}</nb-option>
          <nb-option *ngFor="let c of courses" [value]="c.id">{{ c.name }}</nb-option>
        </nb-select>
      </div>

      <div class="date-row">
        <div class="form-field">
          <label class="label">
            {{ "pages.learnings.fields.validUntil" | translate }}
            <nb-icon
              icon="question-mark-circle-outline"
              class="hint-icon"
              nbPopover="{{ 'pages.learnings.hints.validUntil' | translate }}"
              nbPopoverTrigger="hover"
              nbPopoverPlacement="bottom"
            ></nb-icon>
          </label>
          <input nbInput fullWidth fieldSize="small" type="date" name="valid_until" [(ngModel)]="model.valid_until" />
        </div>
        <div class="form-field">
          <label class="label">
            {{ "pages.learnings.fields.reviewAt" | translate }}
            <nb-icon
              icon="question-mark-circle-outline"
              class="hint-icon"
              nbPopover="{{ 'pages.learnings.hints.reviewAt' | translate }}"
              nbPopoverTrigger="hover"
              nbPopoverPlacement="bottom"
            ></nb-icon>
          </label>
          <input nbInput fullWidth fieldSize="small" type="date" name="review_at" [(ngModel)]="model.review_at" />
        </div>
      </div>

      <!-- Template scope: client-wide learnings only. Without it a house rule
           like "always cite the exam regulations" would hit support bots too. -->
      <div class="form-field" *ngIf="scope === 'client'">
        <label class="label">
          {{ "pages.learnings.fields.appliesTo" | translate }}
          <nb-icon
            icon="question-mark-circle-outline"
            class="hint-icon"
            nbPopover="{{ 'pages.learnings.hints.appliesTo' | translate }}"
            nbPopoverTrigger="hover"
            nbPopoverPlacement="bottom"
          ></nb-icon>
        </label>
        <nb-toggle
          [nbTooltip]="'pages.learnings.hints.allTemplates' | translate"
          [checked]="allTemplates"
          (checkedChange)="onAllTemplatesChange($event)"
        >
          {{ "pages.learnings.fields.allTemplates" | translate }}
        </nb-toggle>
        <nb-select
          *ngIf="!allTemplates"
          multiple
          fullWidth
          size="small"
          name="templates"
          class="template-select"
          [class.al-required-missing]="f.submitted && templateSelectionEmpty"
          [selected]="model.applies_to_templates || []"
          (selectedChange)="onTemplatesChange($event)"
          [placeholder]="'pages.learnings.fields.selectTemplates' | translate"
        >
          <nb-option *ngFor="let tpl of templateOptions" [value]="tpl">
            {{ "enums.assistantTemplate." + tpl | translate }}
          </nb-option>
        </nb-select>
        <span *ngIf="f.submitted && templateSelectionEmpty" class="hint hint--warning">
          {{ "pages.learnings.fields.templatesEmpty" | translate }}
        </span>
      </div>

      <div class="toggle-row">
        <nb-toggle
          *ngIf="!isExample"
          name="always_apply"
          [(ngModel)]="model.always_apply"
          [nbTooltip]="'pages.learnings.hints.alwaysApply' | translate"
        >
          {{ "pages.learnings.fields.alwaysApply" | translate }}
        </nb-toggle>
        <nb-toggle name="is_active" [(ngModel)]="model.is_active" [nbTooltip]="'pages.learnings.hints.active' | translate">
          {{
            (model.is_active
              ? "pages.learnings.status.active"
              : "pages.learnings.status.inactive"
            ) | translate
          }}
        </nb-toggle>
      </div>
    </nb-card-body>

    <nb-card-footer>
      <button nbButton status="basic" size="small" type="button" (click)="close()">
        {{ "buttons.cancel" | translate }}
      </button>
      <button nbButton status="primary" size="small" type="submit">
        {{ "buttons.save" | translate }}
      </button>
    </nb-card-footer>
  </nb-card>
</form>
